import { PublicClientApplication } from "@azure/msal-browser";
import config from "../config/config";

const msalConfig = {
  auth: {
    clientId: config.AzureAd.ClientId,
    authority: `https://login.microsoftonline.com/${config.AzureAd.TenantId}`,
    redirectUri: config.AzureAd.RedirectUri,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;